/** @format */
import { Component, Inject, Input, OnInit, Optional, ViewEncapsulation } from '@angular/core';
import { CustomStudyDraft } from 'common-typescript/types';
import { ComponentDowngradeMappings, DowngradedComponent, StaticMembers } from 'sis-common';
import { PLAN_ACTIONS_SERVICE_INJECTION_TOKEN, LegacyPlanActionsService } from '../plan-actions-service/plan-actions.service';

@StaticMembers<DowngradedComponent>()
@Component({
    selector: 'sis-plan-custom-study-draft',
    templateUrl: './plan-custom-study-draft.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class PlanCustomStudyDraftComponent implements OnInit {
    static downgrade: ComponentDowngradeMappings = {
        moduleName: 'sis-components.plan.planCustomStudyDraft',
        directiveName: 'sisPlanCustomStudyDraft',
    };

    canOpenCustomStudyDraftInfoModal: boolean;

    @Input() customStudyDraft: CustomStudyDraft;

    constructor(@Optional() @Inject(PLAN_ACTIONS_SERVICE_INJECTION_TOKEN) private planActionsService: LegacyPlanActionsService) {}

    ngOnInit() {
        this.canOpenCustomStudyDraftInfoModal = !!this.planActionsService?.openCustomStudyDraftInfoModal;
    }

    openCustomStudyDraftInfoModal(customStudyDraft: CustomStudyDraft) {
        this.planActionsService?.openCustomStudyDraftInfoModal?.(customStudyDraft);
    }
}
